import ApplicationAdapter from 'uplisting-frontend/adapters/application';

export default class TeamConversationAdapter extends ApplicationAdapter {
  markRead(id: string): Promise<object> {
    const url = `${this.buildURL('team-conversation', id)}/read`;

    return this.ajax(url, 'POST') as Promise<object>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'team-conversation': TeamConversationAdapter;
  }
}
